export default __webpack_public_path__ + "static/media/giftbox.09743573.webp";